import { render } from "./SvgView.vue?vue&type=template&id=51e47499"
import script from "./SvgView.vue?vue&type=script&lang=js"
export * from "./SvgView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__